export default class Operation {
    action;
    startInOld;
    endInOld;
    startInNew;
    endInNew;
    constructor({ action, startInOld, endInOld, startInNew, endInNew }) {
        this.action = action;
        this.startInOld = startInOld;
        this.endInOld = endInOld;
        this.startInNew = startInNew;
        this.endInNew = endInNew;
    }
}
//# sourceMappingURL=Operation.js.map